<div class="main-container">

	<p class="empty-message-container" *ngIf="!payloadType || !payload">There is no information to show!</p>

	<ng-container *ngIf="payloadType === GenericInfoPayloadType.MassRequestUpdate">
		<h3>Request Update</h3>
		<div class="main-form">

			<p>An update has been requested by <strong>{{ payload.requesterName }}</strong> with the
				following note:</p>

			<p class="comment">{{ payload.comment }}</p>

			<hr />

			<div class="job-container" *ngFor="let job of payload.jobs">
				<a mat-flat-button [href]="'/' + job.urlHash" target="_blank">
					<p>{{ job.jobName }}</p>
					<span>{{ job.projectName }}</span>
					<span *ngIf="job.siteName">{{ job.siteName }}</span>
				</a>
			</div>
		</div>

	</ng-container>
</div>